import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { useSubscribeForm } from '@contexts/SubscribeFormContext';
import { READ_ONLY_MODE, READ_ONLY_PHRASE } from '@src/env';
import { SelectedOffer } from '@utils/backend-api/subscribe';
import { YOUNG_PROFESSIONALS_PLAN } from '@utils/constants';

import PaymentForm from '../pages/Subscribe/Forms/PaymentForm';
import SignupForm from '../pages/Subscribe/Forms/SignupForm';

const queryClient = new QueryClient();

export interface SubscriptionFormProps {
  buttonText: string;
  formLocation: string;
  presentedOfferCodes: string[];
  referringSubscriberGuid?: string;
  referringSubscriberName?: string;
  selectedOffer: SelectedOffer;
  stripeCustomerId?: string;
}

const SubscriptionForm = (props: SubscriptionFormProps) => {
  const {
    user: { dob, stripeCustomerId },
  } = useSubscribeForm();
  const isYPPlan = props.selectedOffer.code.includes(YOUNG_PROFESSIONALS_PLAN);

  // Show payment form only if the user has a stripe customer id and in case of a YP plan, we want to make sure they have a date of birth too
  const showPaymentForm = stripeCustomerId && (!isYPPlan || (isYPPlan && dob));

  return (
    <div>
      {READ_ONLY_MODE ? (
        <div className="warning mt-28">
          <h3>Purchases are temporarily unavailable</h3>
          Sorry, we&apos;re doing some necessary site maintenance now, and this feature isn&apos;t
          available. Please try again in {READ_ONLY_PHRASE || '10-15 minutes'}. Thanks for your
          patience!
        </div>
      ) : (
        <QueryClientProvider client={queryClient}>
          <SignupForm {...props} />
          {showPaymentForm && <PaymentForm {...props} stripeCustomerId={stripeCustomerId} />}
        </QueryClientProvider>
      )}
    </div>
  );
};

export default SubscriptionForm;
